import { useTranslation } from 'react-i18next';
import {Container, Typography, Button, IconButton} from "@mui/material"
import { Wrapper, FaqTitle } from '../style'
import {useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function FaqPage() {
  const { i18n, t } = useTranslation('translation', { keyPrefix: 'auth' });
  const navigate = useNavigate()

  const meta = JSON.parse(localStorage.getItem('metadata'))
  const content = meta?.faq

  const direction = i18n.language === 'en' ? 'ltr' : 'rtl'
  return (
   <Container maxWidth='xs' dir={direction}>
     <Wrapper>
       <FaqTitle>
         <IconButton>
           <ArrowBackIcon onClick={() => navigate(-1)} />
         </IconButton>
       </FaqTitle>
      <Typography variant="caption" component="span" align="center">
        {content?.indexOf('</') !== -1
         ? <div dangerouslySetInnerHTML={{__html: content.replace(/\n/g, '<br />')}}>
         </div>
         : content
        }
      </Typography>
       <Button onClick={() => navigate(-1)}>
         {t('back')}
       </Button>
     </Wrapper>
   </Container>
  );
}
